export function PerDaySlash() {
  return (
    <span aria-label="per" data-testid="PerDaySlash">
      /
    </span>
  )
}
